import * as actionTypes from '../actions/actionTypes'
import { changeOddType } from '../actions/config';
import { getCompetitorImage, openEventStats, openCompetitorStats } from '../actions/customerMethods';
import { getUniqueTournamentId } from '../reducers/matches';
import { v4 as uuidv4 } from 'uuid';
import { getLastServerContentTimestampMs } from '../reducers/timings';

let instance: any = null;

export default class CustomerMethods {
  _subscribers: any
  _store: any

  constructor () {
    if(!instance) {
      instance = this;
      this._subscribers = [];
    }
    return instance;
  }

  registerSubscriber(subscriber: any) {
    const id = uuidv4();
    const subscription = {
      id: id,
      f: subscriber,
    };
    this._subscribers.push(subscription);
    return id;
  }

  unregisterSubscriber(id: string) {
    this._subscribers = this._subscribers.filter((subscription: any) => {
      return subscription.id !== id;
    });
  }

  handleSubscription(action: any) {
    this._subscribers.forEach((subscription: any) => subscription.f(action));
  }

  handleDispatch ( messageObject: any ) {
    //console.log('handle dispatch', messageObject)
    const store = this._store;

    // TODO: implement a data parser to check weather the data is correct or dangerous
    switch( messageObject.type ) {
      case actionTypes.OVERLAY_TOGGLE:
        store.dispatch({type: actionTypes.OVERLAY_TOGGLE});
        break;
      case actionTypes.REQUEST_CURRENT_PHASE_DATA:
        store.dispatch({type: actionTypes.REQUEST_CURRENT_PHASE_DATA});
        break;
      case actionTypes.REQUEST_CURRENT_DATA:
        store.dispatch( { type: actionTypes.PREPARE_CURRENT_DATA } );
        break;
      case actionTypes.CUSTOMER_METHODS_SEEK_EVENTS:
        // store.dispatch(seekEvents(messageObject.data.type))
        console.warn("this event isn't supported by Virtual In-Play Tennis");
        break;
      case actionTypes.CHANGE_ODD_TYPE:
        store.dispatch(changeOddType(messageObject.data));
        break;
      case actionTypes.CUSTOMER_METHODS_GET_COMPETITOR_IMAGE:
        store.dispatch(getCompetitorImage(messageObject.data));
        break;
      case actionTypes.CUSTOMER_METHODS_OPEN_EVENT_STATS:
        store.dispatch(openEventStats(messageObject.data));
        break;
      case actionTypes.CUSTOMER_METHODS_OPEN_COMPETITOR_STATS:
        store.dispatch(openCompetitorStats(messageObject.data));
        break;
      case actionTypes.VIDEO_PLAYER_STOP:
        store.dispatch( { type: actionTypes.VIDEO_PLAYER_STOP } );
        break;
      case actionTypes.VIDEO_PLAYER_CREATE:
        store.dispatch({type: actionTypes.VIDEO_PLAYER_ACTION, videoPlayerOperation: 'create'});
        break;
      case actionTypes.VIDEO_PLAYER_DESTROY:
          store.dispatch({type: actionTypes.VIDEO_PLAYER_ACTION, videoPlayerOperation: 'destroy'});
          break;
      default:
        return
    }
  }

  addStore ( store: any ) {
    if(this._store) {
      return;
    }
    this._store = store;
    let action: any;
    let storeData: any;
    let message: any;

    const customerMethodData = {
      application: 'online', // TODO: implement a static configuration!
      sport: 'tennis in-play', // TODO: implement a static configuration!
      server_timestamp: null,
      unique_tournament_id: null
    };

      this._store.subscribe(() => {
          storeData = this._store.getState();
          action = storeData.lastAction;

          switch (action.type) {
              case actionTypes.CUSTOMER_METHODS_PHASE_CHANGE:
                  message = {
                      ...action,
                      data: {
                          ...action.data,
                          ...customerMethodData,
                          server_timestamp: Math.floor(getLastServerContentTimestampMs(storeData)/1000),
                          unique_tournament_id: getUniqueTournamentId(storeData)
                      }
                  };
                  break;
              case actionTypes.CUSTOMER_METHODS_OPEN_EVENT:
              case actionTypes.CUSTOMER_METHODS_CLOSE_EVENT:
              case actionTypes.CUSTOM_INTERNAL_DATA:
                  message = {
                      ...action
                  };
                  break;
              case actionTypes.CUSTOMER_METHODS_SEND_CURRENT_PHASE_DATA:
                  message = {
                      ...action,
                      data: {
                          ...action.data
                      }
                  };
                  break;
              case actionTypes.BWG_METHODS_SWITCH_COMPETITOR:
                  message = {
                      ...action,
                      data: {
                          ...action.data
                      }
                  };
                  break;
              //case actionTypes.BWG_METHODS_SET_ODDS_STATE:
              case actionTypes.CUSTOMER_METHODS_PLACE_BETS:
              case actionTypes.CUSTOMER_METHODS_SWITCH_EVENTS:
              case actionTypes.CUSTOMER_METHODS_SWITCH_ALL_EVENTS:
                  message = {
                      ...action,
                      data: {
                          ...action.data,
                          ...customerMethodData,
                          server_timestamp: Math.floor(getLastServerContentTimestampMs(storeData)/1000),
                          unique_tournament_id: getUniqueTournamentId(storeData)
                      }
                  };
                  break;
              case actionTypes.CUSTOMER_METHODS_SET_HEIGHT:
                  message = {
                      type: actionTypes.CUSTOMER_METHODS_SET_HEIGHT,
                      data: {
                          ...action.data,
                          ...customerMethodData,
                          server_timestamp: Math.floor(getLastServerContentTimestampMs(storeData)/1000),
                          unique_tournament_id: getUniqueTournamentId(storeData)
                      }
                  };
                  break;
              case actionTypes.INIT_APPLICATION_FINISHED:
                  message = {
                      type: actionTypes.INIT_APPLICATION_FINISHED,
                      data: {
                          ...action.data
                      }
                  };
                  break;
              default:
                  return;
          }

          this.handleSubscription(message)
      })
  }
}
